import { useState } from "react";
import { spotlightItems } from "@/mocks/homeContent";

export default function SpotlightSection() {
  const [saved, setSaved] = useState<boolean[]>(() => spotlightItems.map(() => false));

  const toggle = (i: number) => setSaved((prev) => prev.map((v, idx) => (idx === i ? !v : v)));

  return (
    <section id="spotlight" className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-shell px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-accent-700">DEEP DISSECT</p>
            <h2 className="mt-1 text-2xl font-black text-foreground-950 md:text-3xl">争议焦点 · 深度拆解</h2>
            <p className="mt-2 text-sm text-foreground-500">不只搬料，也把「为什么火、怎么传开」讲清楚。</p>
          </div>
          <a href="#spotlight" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-600">
            全部焦点
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {spotlightItems.map((item, idx) => (
            <article
              key={item.title}
              className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-transform duration-200 hover:-translate-y-1"
            >
              <div className="relative aspect-[800/520] w-full overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`${item.area}：${item.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-foreground-950/70 px-2 py-1 text-[11px] font-medium text-background-50 backdrop-blur">
                  {item.area}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-[11px] font-medium uppercase tracking-wider text-secondary-600">{item.kicker}</p>
                <h3 className="mt-1 text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{item.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1 font-medium text-primary-700">
                      <i className="ri-fire-line" aria-hidden="true"></i>
                      {item.heat}
                    </span>
                    <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-secondary-900">{item.tag}</span>
                  </div>
                  <button
                    type="button"
                    onClick={() => toggle(idx)}
                    aria-pressed={saved[idx]}
                    aria-label={saved[idx] ? "取消收藏" : "收藏到清单"}
                    className={`flex h-8 w-8 items-center justify-center rounded-md transition-colors ${
                      saved[idx] ? "bg-accent-500 text-foreground-950" : "bg-background-100 text-foreground-600 hover:bg-background-200"
                    }`}
                  >
                    <i className={`${saved[idx] ? "ri-bookmark-fill" : "ri-bookmark-line"} text-base`} aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}